import React from 'react'

import { Alert, AppSvg, FormattedHTMLMessage, NavMenuItem, newIcons, Spinner } from '@web/walter-ui-kit'
import { GetCard } from '@web/walter-lib/api'
import s from './s.module.css'
import { lang } from './lang'
import { SettingsTabs } from '~pages/CardsPage/Cards/Settings/SettingsModal/types'
import { useGetThreeDSMethods } from '~api'

interface Props {
    setTab: (tab: SettingsTabs) => void
    card?: GetCard
}

function ArrowIcon() {
    return (
        <div className={s.afterIcon}>
            <AppSvg path="new-icons" size={24} svgName={newIcons.ic24ChevronRight} />
        </div>
    )
}

// eslint-disable-next-line max-lines-per-function
function General({ setTab, card }: Props) {
    const { data: methodsData, isLoading } = useGetThreeDSMethods({ id: card?.id || '' })

    const isSms = methodsData?.methods?.find(method => method.name === 'OTPSMS')?.active
    const isEmail = methodsData?.methods?.find(method => method.name === 'OTPEMAIL')?.active
    const isBio = methodsData?.methods?.find(method => method.name === 'BIOMETRIC')?.active
    const isOutofband = methodsData?.methods?.find(method => method.name === 'OUTOFBAND')?.active
    const isKba = methodsData?.methods?.find(method => method.name === 'KBA')?.active

    if (isLoading) {
        return (
            <div className="flex justify-center pb-6">
                <Spinner intent="accent" size={36} />
            </div>
        )
    }

    return (
        <div className={s.wrap}>
            <FormattedHTMLMessage {...lang.title} className={s.title} />
            <div className={s.content}>
                <div className={s.alertWrap}>
                    <Alert
                        icon={<AppSvg svgName={newIcons.ic16Alert} size={16} path="new-icons" className={s.alert} />}
                        dataPointer="approve_alert"
                        text={
                            <div className={s.alertContent}>
                                <FormattedHTMLMessage {...lang.alert} values={{ transactionCount: 12 }} />
                                <span className={s.learnMore} onClick={() => setTab(SettingsTabs.threeDSAbout)}>
                                    <FormattedHTMLMessage {...lang.learnMore} />
                                    <AppSvg
                                        svgName={newIcons.ic16ChevronDown}
                                        size={16}
                                        path="new-icons"
                                        className={s.arrow}
                                    />
                                </span>
                            </div>
                        }
                        type="accent"
                    />
                </div>
                <div className={s.menu}>
                    {isSms && (
                        <NavMenuItem
                            icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24Phone} />}
                            type="button"
                            size="l"
                            onClick={() => setTab(SettingsTabs.threeDSSms)}
                            dataPointer="sms_tab"
                            after={<ArrowIcon />}
                            variant="secondary"
                        >
                            <FormattedHTMLMessage {...lang.sms} />
                        </NavMenuItem>
                    )}
                    {isEmail && (
                        <NavMenuItem
                            icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24Mail} />}
                            type="button"
                            size="l"
                            onClick={() => setTab(SettingsTabs.threeDSEmail)}
                            dataPointer="email_tab"
                            after={<ArrowIcon />}
                            variant="secondary"
                        >
                            <FormattedHTMLMessage {...lang.email} />
                        </NavMenuItem>
                    )}
                    {isBio && (
                        <NavMenuItem
                            icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24TouchId} />}
                            type="button"
                            size="l"
                            onClick={() => setTab(SettingsTabs.threeDSBio)}
                            dataPointer="biometrics_tab"
                            after={<ArrowIcon />}
                            variant="secondary"
                        >
                            <FormattedHTMLMessage {...lang.bio} />
                        </NavMenuItem>
                    )}
                    {isOutofband && (
                        <NavMenuItem
                            icon={<AppSvg size={24} path="new-icons" svgName={newIcons.ic24Devices} />}
                            type="button"
                            size="l"
                            onClick={() => setTab(SettingsTabs.threeDSApproval)}
                            dataPointer="in_wallet_tab"
                            after={<ArrowIcon />}
                            variant="secondary"
                        >
                            <FormattedHTMLMessage {...lang.approval} />
                        </NavMenuItem>
                    )}
                    {isKba && (
                        <NavMenuItem
                            icon={
                                <AppSvg
                                    size={24}
                                    path="new-icons"
                                    svgName={newIcons.ic24QuestionCircleOutline + '?qq'}
                                />
                            }
                            type="button"
                            size="l"
                            onClick={() => setTab(SettingsTabs.threeDSSecurity)}
                            dataPointer="security_tab"
                            after={<ArrowIcon />}
                            variant="secondary"
                        >
                            <FormattedHTMLMessage {...lang.security} />
                        </NavMenuItem>
                    )}
                </div>
            </div>
        </div>
    )
}

export default General
